import React, { useEffect } from "react";

import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import "./styles/App.css";

import "semantic-ui-css/semantic.min.css";

import "./styles/variable.css";

import ProtectedRoute from "./utils/ProtectedRoute";

import DashboardLayout from "./pages/components/DashboardLayout";

import { UserProvider } from "./utils/UserContext";

import { PropertyProvider } from "./utils/PropertyContext";

import Login from "./pages/Login/Login";

import Home from "./pages/Dashboard/Home/Home";

import NewProperty from "./pages/Dashboard/NewProperty/NewProperty";

import ReleaseProperties from "./pages/Dashboard/ReleaseProperties/ReleaseProperties";

import AllProperties from "./pages/Dashboard/AllProperties/AllProperties";

import Users from "./pages/Dashboard/Users/Users";

import DetailedProperty from "./pages/Dashboard/DetailedProperty/DetailedProperty";

import FavoritesProperties from "./pages/Dashboard/FavoritesProperties/FavoritesProperties";

import Payments from "./pages/Dashboard/Payments/Payments";

import AccessDenied from "./pages/AccessDenied/AccessDenied";

import ServerControll from "./pages/ServerControll/ServerControll";

import ResetPassword from "./pages/ResetPassword/ResetPassword";

import SearchResults from "./pages/Dashboard/SearchResults/SearchResults";

export default function App() {
  const location = useLocation();

  const navigate = useNavigate();

  const state = location.state;

  useEffect(() => {
    const currentUserId = localStorage.getItem("currentUserId");

    const loginExpiration = localStorage.getItem("loginExpiration");

    const isLoggedIn = currentUserId && new Date(loginExpiration) > new Date();

    if (isLoggedIn && location.pathname === "/") {
      navigate("/dashboard/");
    }
  }, [location, navigate]);

  return (
    <div className="App">
      <Routes location={state?.backgroundLocation || location}>
        <Route path="/" element={<Login />} />

        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/controladores-servidor/" element={<ServerControll />} />

        <Route path="/acesso-negado/" element={<AccessDenied />} />

        <Route
          path="/dashboard"
          element={
            <UserProvider>
              <PropertyProvider>
                <ProtectedRoute
                  element={<DashboardLayout />}
                  allowedRoles={[
                    "admin",

                    "assistant",

                    "imobiliaria",

                    "common",

                    "corretorInd",
                  ]}
                />
              </PropertyProvider>
            </UserProvider>
          }
        >
          <Route index element={<Home />} />

          <Route
            path="adicionar-imovel"
            element={
              <ProtectedRoute
                element={<NewProperty />}
                allowedRoles={["admin", "assistant"]}
              />
            }
          />

          <Route
            path="liberacao"
            element={
              <ProtectedRoute
                element={<ReleaseProperties />}
                allowedRoles={["admin", "assistant"]}
              />
            }
          />

          <Route path="imoveis" element={<AllProperties />} />

          <Route path="imoveis/busca" element={<SearchResults />} />

          <Route path="imoveis/:id" element={<DetailedProperty />} />

          <Route path="imoveis/favoritos" element={<FavoritesProperties />} />

          <Route
            path="usuarios"
            element={
              <ProtectedRoute element={<Users />} allowedRoles={["admin"]} />
            }
          />

          <Route
            path="entidades"
            element={
              <ProtectedRoute element={<Users />} allowedRoles={["admin"]} />
            }
          />

          <Route path="pagamentos" element={<Payments />} />
        </Route>
      </Routes>

      {state?.backgroundLocation && (
        <Routes>
          <Route
            path="/dashboard/imoveis/:id/"
            element={<DetailedProperty />}
          />
        </Routes>
      )}
    </div>
  );
}
